import { RootState } from 'store';

export const getAliasesByProviderSelector = (store: RootState): any | null => store.aliasesByProvider.data || null;  // TODO: CHANGE ANY TO ALIASES_RESPONSE

export const getAliasesByProviderIsLoadingSelector = (store: RootState): boolean => store.aliasesByProvider.isLoading;
